// ✅ FIXED VERSION OF PhotoItem.jsx
import React, { useRef, useEffect } from "react";
import { useDrag, useDrop } from "react-dnd";
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import s from "./PhotosList.css";
import messages from "../../locale/messages";
import TickIcon from "/public/SiteIcons/correct.svg";

const PhotoItem = ({
  item,
  index,
  path,
  isCover,
  movePhoto,
  dropPhoto,
  onChangeCover,
  onDelete,
  scrollContainer,
}) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: "PHOTO",
    hover(draggedItem, monitor) {
      if (draggedItem.index === index) return;
      movePhoto(draggedItem.index, index);
      draggedItem.index = index;

      const clientOffset = monitor.getClientOffset();
      if (!clientOffset || !scrollContainer) return;

      const rect = scrollContainer.getBoundingClientRect();
      const scrollThreshold = 80; // more responsive edge detection
      const scrollSpeed = 30; // smaller step, faster frequency

      let scrollingDirection = null;

      if (clientOffset.y < rect.top + scrollThreshold) {
        scrollingDirection = "up";
      } else if (clientOffset.y > rect.bottom - scrollThreshold) {
        scrollingDirection = "down";
      }

      if (scrollingDirection) {
        const smoothScroll = () => {
          const currentOffset = monitor.getClientOffset();
          if (!currentOffset) return;

          const stillNearTop = currentOffset.y < rect.top + scrollThreshold;
          const stillNearBottom =
            currentOffset.y > rect.bottom - scrollThreshold;

          if (
            (scrollingDirection === "up" && stillNearTop) ||
            (scrollingDirection === "down" && stillNearBottom)
          ) {
            scrollContainer.scrollBy({
              top: scrollingDirection === "up" ? -scrollSpeed : scrollSpeed,
              behavior: "smooth",
            });
            requestAnimationFrame(smoothScroll);
          }
        };

        requestAnimationFrame(smoothScroll);
      }
    },
    drop: dropPhoto,
  });

  const [{ isDragging }, drag] = useDrag({
    type: "PHOTO",
    item: { id: item.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: !isCover,
  });

  drag(drop(ref));

  // 👇 Ensure DOM reflects coverPhoto change immediately
  useEffect(() => {
    if (isCover) {
      document.querySelectorAll(`.photoTickIcon`).forEach((el) => {
        el.closest("." + s.coverPhotoSection)?.classList.add("show");
      });
    }
  }, [isCover]);

  return (
    <div
      ref={ref}
      className={cx(s.positionRelative)}
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      <div
        className={s.photoListBgImage}
        style={{ backgroundImage: `url(${path}x_medium_${item.name})` }}
      />
      <div className="photoListDropDown">
        <DropdownButton bsSize="small" title="" id={`dropdown-${item.id}`}>
          {!isCover && (
            <MenuItem onClick={onChangeCover}>
              <FormattedMessage {...messages.setAsCoverPhoto} />
            </MenuItem>
          )}
          <MenuItem onClick={onDelete}>
            <FormattedMessage {...messages.delete} />
          </MenuItem>
        </DropdownButton>
      </div>

      {isCover && (
        <div
          className={cx(
            s.coverPhotoSection,
            "bgBlackTwo",
            "textWhite",
            "svgImg"
          )}
        >
          <img src={TickIcon} className={cx(s.tickIcon, "photoTickIcon")} />
          <FormattedMessage {...messages.setCover} />
        </div>
      )}
    </div>
  );
};

export default PhotoItem;
